// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-wrapper {
  margin-top: 20px;
  padding: 30px;
  background-color: var(--ion-color-text-white);
}

.form-section {
  margin-top: 10px;
  margin-bottom: 30px;
}
.form-section .form-section-title {
  margin-bottom: 20px;
  color: var(--ion-color-medium-shade);
}
.form-section .form-section-title mat-icon {
  vertical-align: middle;
  margin-right: 5px;
}
.form-section .form-section-title .title-label {
  vertical-align: middle;
  font-size: 0.9rem;
}
.form-section mat-form-field {
  width: 100%;
  padding-right: 30px;
}
.form-section .old-password {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/profile/profile.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,6CAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;AACE;EACE,mBAAA;EACA,oCAAA;AACJ;AACI;EACE,sBAAA;EACA,iBAAA;AACN;AAEI;EACE,sBAAA;EACA,iBAAA;AAAN;AAIE;EACE,WAAA;EACA,mBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ","sourcesContent":[".profile-wrapper {\n  margin-top: 20px;\n  padding: 30px;\n  background-color: var(--ion-color-text-white);\n}\n\n.form-section {\n  margin-top: 10px;\n  margin-bottom: 30px;\n\n  .form-section-title {\n    margin-bottom: 20px;\n    color: var(--ion-color-medium-shade);\n    \n    mat-icon {\n      vertical-align: middle;\n      margin-right: 5px\n    }\n    \n    .title-label {\n      vertical-align: middle;\n      font-size: .9rem;\n    }\n  }\n  \n  mat-form-field {\n    width: 100%;\n    padding-right: 30px;\n  }\n\n  .old-password {\n    margin-bottom: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
